// Hook do pobierania slownika typow ofert – GET /sales-crm/offer-types

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmOfferTypeItem {
  id: number;
  name: string;
  // Klasyfikator behavioralny: 'one_time' lub 'periodic'.
  type: string;
  symbol: string;
}

export interface IGetSalesCrmOfferTypesResponse {
  page?: number;
  total_count?: number;
  total_pages?: number;
  items: ISalesCrmOfferTypeItem[];
}

const getSalesCrmOfferTypes = (): Promise<IGetSalesCrmOfferTypesResponse> =>
  axios.get('/sales-crm/offer-types');

export const useGetSalesCrmOfferTypes = (
  options?: UseQueryOptions<IGetSalesCrmOfferTypesResponse, IError>
) =>
  useQuery<IGetSalesCrmOfferTypesResponse, IError>(
    ['sales-crm', 'offer-types'],
    () => getSalesCrmOfferTypes(),
    {
      // Slownik zmienia sie rzadko — keszujemy 5 minut.
      staleTime: 5 * 60 * 1000,
      ...options
    }
  );
